import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/play-button.svg'


const _withScopeId = n => (_pushScopeId("data-v-09d196ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "podcast-episodes" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEpisodes, (ep, epIndex) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "podcast-episodes__episode",
        key: epIndex
      }, [
        _createElementVNode("h3", null, [
          _createElementVNode("a", {
            href: ep.link,
            target: "_blank",
            title: "Listen to episode on SoundCloud"
          }, [
            _hoisted_3,
            _createElementVNode("span", null, _toDisplayString(ep.title), 1)
          ], 8, _hoisted_2)
        ]),
        _createElementVNode("h4", null, _toDisplayString(_ctx.formatDate(ep.date, true)) + " — (" + _toDisplayString(_ctx.formatDuration(ep.duration)) + ")", 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.trimDescription(ep.description)), 1)
      ]))
    }), 128))
  ]))
}